export default __webpack_public_path__ + "static/media/info-order-received.b0ec9a77.svg";